// src/utils/normalizeText.js
// Normalise un texte pour une recherche insensible aux accents/majuscules - NE PAS MODIFIER

export const normalizeText = (text) => {
    if (!text) return '';
    return text
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, ''); // retire les accents (é → e, ô → o...)
  };
  
  export const textIncludes = (haystack, needle) => {
    return normalizeText(haystack).includes(normalizeText(needle));
  };